export default "__VITE_ASSET__d165f71b__"